import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

// Hook personnalisé pour utiliser le contexte
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [fetchError, setFetchError] = useState(false);
    const navigate = useNavigate();

    // ✅ Déconnexion : Seulement si l'utilisateur le demande
    const logout = useCallback(() => {
        console.log("🔹 Déconnexion volontaire");
        localStorage.removeItem("token");
        localStorage.removeItem("userEmail");
        setUser(null);  // ✅ Efface toutes les données utilisateur
        setIsLoading(false);
        navigate("/login");
    }, [navigate]);    

    // ✅ Récupération utilisateur SI il y a un token stocké
    useEffect(() => {
        console.log("📌 Execution de `useEffect()` -> Vérification utilisateur");
    
        const token = localStorage.getItem("token");
        const storedEmail = localStorage.getItem("userEmail");
    
        console.log("📌 Vérification token et email:", { token, storedEmail });
    
        if (!token || !storedEmail) {
            console.warn("⚠️ Aucun token ou email trouvé, mais conservation de l'état utilisateur.");
            setIsLoading(false);
            return;
        }
    
        const fetchUser = async () => {
            try {
                console.log("📌 Tentative de récupération utilisateur...");
        
                const token = localStorage.getItem("token");
                const storedEmail = localStorage.getItem("userEmail");
                
                // Choix dynamique de l’URL backend
                const BACKEND_URL =
                window.location.hostname === "localhost"
                    ? process.env.REACT_APP_BACKEND_URL_LOCAL + "/api"
                    : process.env.REACT_APP_BACKEND_URL_PROD + "/api";

                const res = await axios.post(`${BACKEND_URL}/utilisateurs/getUser`,
                    { Email: storedEmail },
                    { headers: { Authorization: `Bearer ${token}` } }
                );
        
                console.log("✅ Réponse de l'API `/getUser` :", res.data); // 🚀 Vérifie si Nom et Rôle sont bien là !
        
                setUser({
                    id: res.data.id,
                    Nom: res.data.Nom,  
                    Email: res.data.Email,
                    Rôle: res.data.Rôle  
                });
        
                setFetchError(false);
            } catch (err) {
                console.error("❌ Erreur récupération utilisateur :", err.response?.data || err);
                setFetchError(true);
            } finally {
                setIsLoading(false);
            }
        };                

        fetchUser();
    }, []);    

    // ✅ Connexion : Mise à jour immédiate de l'utilisateur
    const login = async (Email, Password) => {
        try {
            if (!Email || !Password) {
                console.error("❌ ERREUR: `login()` appelé sans email ou mot de passe !");
                return;
            }
    
            setIsLoading(true);
    
            console.log("📌 Appel `login()` avec Email :", Email);
            
            const BACKEND_URL =
                window.location.hostname === "localhost"
                    ? process.env.REACT_APP_BACKEND_URL_LOCAL + "/api"
                    : process.env.REACT_APP_BACKEND_URL_PROD + "/api";
    
            const res = await axios.post(`${BACKEND_URL}/utilisateurs/login`, { Email, Password });
    
            console.log("🔹 Réponse API reçue :", res.data);
    
            const { token, utilisateur } = res.data;
    
            if (!utilisateur || typeof utilisateur.Email !== "string") {
                throw new Error("❌ ERREUR: L'email reçu n'est pas valide !");
            }
    
            // ✅ Stockage du token et de l'email
            localStorage.setItem("token", token);
            localStorage.setItem("userEmail", utilisateur.Email);
    
            // ✅ Stockage explicite des infos de l'utilisateur
            setUser({
                id: utilisateur.id,
                Nom: utilisateur.Nom,  // Ajout de `Nom`
                Email: utilisateur.Email,
                Rôle: utilisateur.Rôle  // Ajout de `Rôle`
            });
    
            console.log("✅ `user` mis à jour après connexion :", utilisateur);
    
            setTimeout(() => {
                console.log("🔹 Redirection vers /dashboard...");
                navigate("/dashboard");
            }, 500);
    
        } catch (err) {
            console.error("❌ Erreur de connexion :", err.response?.data || err);
            alert(err.response?.data?.message || "Email ou mot de passe incorrect.");
        } finally {
            setIsLoading(false);
        }
    };    

    return (
        <AuthContext.Provider value={{ user, login, logout, isLoading, fetchError }}>
            {children}
        </AuthContext.Provider>
    );
};
